// import { stringify as qs_stringify } from 'qs'
import { BsAjax, BsGetcapis, BsUtil } from 'dida-web-common'

// 发奖预判
export function predictCoupons(data) {
  return BsAjax.get(BsGetcapis + '/web/activity-platform/award/predict', {
    params: data
    // deviceId: true
  })
}

// 发奖
export function getCoupon(data) {
  return BsAjax.get(BsGetcapis + '/web/activity-platform/award', {
    params: data
    // deviceId: true
  })
}

// 裂变助力
export function helpGuest(data) {
  return BsAjax.post(BsGetcapis + '/web/activity-platform/interact/guest/help', BsUtil.stringify(data))
}

// 跳转小程序
export function generatescheme(data) {
  return BsAjax.get(BsGetcapis + '/web/active/wechat/generatescheme', {
    params: data
    // deviceId: true
  })
}

// 腾讯广告归因
export function tencentattribution(data) {
  return BsAjax.get(BsGetcapis + '/web/adbase/tencentattribution', {
    params: data
    // deviceId: true
  })
}

// 兑换预判
export function inflationPredict(data) {
  return BsAjax.get(BsGetcapis + '/web/activity-platform/exchange/predict', {
    params: data
    // deviceId: true
  })
}

// 兑换
export function inflationed(data) {
  return BsAjax.get(BsGetcapis + '/web/activity-platform/exchange', {
    params: data
    // deviceId: true
  })
}
